import { nShiftPartnerServiceFragment, transportOrderSuperAdminFragment } from 'apollo/fragments/transport';
import { gql } from 'graphql.macro';

export const transportOpterLogTemplate = gql`
    query transportOpterLog($opterOrderId: Int!) {
        transportOpterLog(opterOrderId: $opterOrderId) {
            DateAndTime
            Status
            POD_Descr
            DEA_FileName
            DEA_Guid
            DateTimeString
            OFF_Id
            hasImage
        }
    }
`;

export const transportsTemplate = gql`
    query transports($filters: TransportOrderFilter, $limit: Int, $offset: Int) {
        transports(filters: $filters, limit: $limit, offset: $offset) {
            ...transportOrderSuperAdminFields
        }
    }
    ${transportOrderSuperAdminFragment}
`;

export const nShiftPartnersTemplate = gql`
    query nShiftPartners {
        nShiftPartners {
            id
            description
            services {
                ...nShiftPartnerServiceFields
            }
        }
    }
    ${nShiftPartnerServiceFragment}
`;

export const transportClinicsTemplate = gql`
    query transportClinics($labId: ID) {
        transportClinics(labId: $labId) {
            _id
            name
            contact {
                address {
                    street
                    city
                    postalCode
                }
            }
        }
    }
`;
